import "./index.scss";

import PrototypePage from "./pages/PrototypePage"; 

import Main from "./pages/Main";
import Session from "./pages/Session";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import Pricing from "./pages/Pricing";
import Confirmation from "./pages/Confirmation";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/authentication/Login";
import { AuthProvider, useAuth } from './context/AuthContext';
import ResetPasswordPage from "./pages/authentication/ResetPasswordPage";
import ChangePassword from "./pages/authentication/ChangePassword";
import SignUp from "./pages/authentication/SignUp";

import './services/amplify-config'; 
import LoginPage from "./pages/authentication/LoginPage";
import Page from "./components/Page";
import { AnalyticsProvider } from "./context/AnalyticsContext";
import Contact from "./pages/Contact";
import Sessions from "./pages/Sessions";
import Demo from "./pages/Demo";
import Experiences from "./pages/Experiences";
import AccountPage from "./pages/authentication/Account";
import QuestionAnswersPage from "./pages/QuestionAnswersPage";
import HomePage from "./pages/HomePage";

import EditGuidePage from "./pages/GuideEditorPage";
import GuideEditorPage from "./pages/GuideEditorPage";
import GuidesListPage from "./pages/GuidesListPage";
import ElementsPage from "./pages/ElementsPage";
import EnvironmentsPage from "./pages/EnvironmentsPage";
import SystemsPage from "./pages/SystemsPage";
import CollectionsPage from "./pages/CollectionsPage";
import CollectionPage from "./pages/CollectionPage";
import Viewer from "./pages/Viewer";

import ProtectedRoute  from "./components/ProtectedRoute";
import ExperiencePage from "./pages/ExperiencePage";
import Leaderboard from "./pages/Leaderboard";


const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Dashboard />} /> */}
        <Route path="public/sessions/:sessionId" element={<Session />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/confirmation" element={<Confirmation />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/iste" element={<Demo />} />
        <Route path="/signup" element={<SignUp />} />

        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route element={<Page pricing={false} code={false} />}>
        <Route path="/" element={<ProtectedRoute />}>
            <Route index element={<HomePage />} />
            <Route path="viewer" element={<Viewer />} />
            <Route path="viewer/:experienceId" element={<Viewer />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewDashboard" />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="prototype" element={<PrototypePage />} />
            <Route path="question" element={<QuestionAnswersPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="experiences/:experienceId" exact element={<ExperiencePage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewAnalytics" />}>
            <Route path="leaderboard" element={<Leaderboard />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudContent" />}>
            <Route path="elements" element={<ElementsPage />} />
            <Route path="environments" element={<EnvironmentsPage />} />
            <Route path="collections" element={<CollectionsPage />} />
            <Route path="collections/:collectionId" element={<CollectionPage />} />
            <Route path="systems" element={<SystemsPage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudExperiences" />}>
            <Route path="experiences" exact element={<Experiences />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewAnalytics" />}>
            <Route path="sessions" exact element={<Sessions />} />
            <Route path="sessions/:sessionId" element={<Session dashboard={true} />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudGuides" />}>
            <Route path="guides" element={<GuidesListPage />} />
            <Route path="guides/:guideId" element={<GuideEditorPage />} />
          </Route>

          
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
